var _path, _path2, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFoundPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 498,
    viewBox: "0 0 520 498",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.955 315.418H150.49V341H140.48V315.418H85.5614V308.188L137.143 243.676H148.266L98.4916 306.52H140.758V283.996H150.49V306.52H169.955V315.418Z",
    fill: "#00B548"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M351.045 315.418H370.51V341H380.52V315.418H435.439V308.188L383.857 243.676H372.734L422.508 306.52H380.242V283.996H370.51V306.52H351.045V315.418Z",
    fill: "#00B548"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1188_2502)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.402 319.92C216.464 319.958 216.526 319.995 216.588 320.031C216.698 320.094 216.81 320.155 216.924 320.212C217.905 320.707 218.959 320.937 219.997 320.923L299.999 320.879C302.383 320.878 304.587 319.602 305.78 317.537L345.804 248.213C346.323 247.346 346.652 246.351 346.732 245.287C346.76 244.923 346.758 244.558 346.726 244.194C346.634 243.142 346.299 242.16 345.778 241.305L305.861 172.077C304.669 170.013 302.467 168.742 300.083 168.742L220.262 168.783C219.045 168.736 217.799 169.022 216.663 169.678C215.565 170.315 214.714 171.216 214.147 172.255L174.146 241.538C172.954 243.604 172.951 246.151 174.143 248.216L214.11 317.525C214.644 318.476 215.417 319.308 216.402 319.92ZM328.523 238.117L296.222 182.1L231.553 182.133L263.858 238.153L328.523 238.117ZM328.516 251.471L263.853 251.508L231.491 307.561L296.153 307.525L328.516 251.471ZM187.63 244.869L219.994 188.812L252.3 244.834L219.936 300.89L187.63 244.869Z",
    fill: "#00B548"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1188_2502)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 291.015,
    r: 39.6522,
    fill: "url(#paint0_linear_1188_2502)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 291.015,
    r: 37.6522,
    stroke: "url(#paint1_linear_1188_2502)",
    strokeWidth: 4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1188_2502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.974 333.19L296.295 351.511C299.4 354.616 304.679 354.616 307.784 351.511L311.51 347.784C314.616 344.679 314.616 339.4 311.51 336.295L293.189 317.974L277.974 333.19Z",
    fill: "#FFCA19"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.939 333.013L293.088 317.864L299.455 324.231L284.306 339.379L277.939 333.013Z",
    fill: "#231511"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M251.579 331.637C241.331 331.637 231.084 327.6 223.01 319.837C207.174 304 207.174 278.537 223.01 263.011C238.847 247.174 264.31 247.174 279.837 263.011C287.289 270.463 291.637 280.711 291.637 291.579C291.637 302.448 287.6 312.384 279.837 320.148C272.074 327.6 261.826 331.637 251.579 331.637ZM251.579 257.421C242.884 257.421 234.189 260.837 227.358 267.358C214.005 280.711 214.005 302.137 227.358 315.49C240.71 328.842 262.137 328.842 275.489 315.49C288.842 302.137 288.842 280.711 275.489 267.358C268.968 260.837 260.274 257.421 251.579 257.421Z",
    fill: "#231511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.253 326.358C282.321 326.358 281.7 326.048 281.079 325.427L275.49 319.837C274.248 318.595 274.248 316.732 275.49 315.49C276.732 314.248 278.595 314.248 279.837 315.49L285.427 321.079C286.669 322.321 286.669 324.184 285.427 325.427C284.805 326.048 283.874 326.358 283.253 326.358Z",
    fill: "#231511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.884 356.79C298.779 356.79 295.984 355.548 293.811 353.374L275.49 335.053C274.248 333.811 274.248 331.948 275.49 330.705L290.705 315.49C291.948 314.248 293.811 314.248 295.053 315.49L313.374 333.811C317.721 338.158 317.721 345.3 313.374 349.958L309.648 353.684C307.784 355.548 304.99 356.79 301.884 356.79ZM282.321 333.19L298.158 349.027C300.021 350.89 303.437 350.89 305.3 349.027L309.027 345.3C310.89 343.437 310.89 340.021 309.027 338.158L293.19 322.321L282.321 333.19Z",
    fill: "#231511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.579 331.637C241.331 331.637 231.084 327.6 223.01 319.837C207.174 304 207.174 278.537 223.01 263.011C238.847 247.174 264.31 247.174 279.837 263.011C287.289 270.463 291.637 280.711 291.637 291.579C291.637 302.448 287.6 312.384 279.837 320.148C272.074 327.6 261.826 331.637 251.579 331.637ZM251.579 257.421C242.884 257.421 234.189 260.837 227.358 267.358C214.005 280.711 214.005 302.137 227.358 315.49C240.71 328.842 262.137 328.842 275.489 315.49C288.842 302.137 288.842 280.711 275.489 267.358C268.968 260.837 260.274 257.421 251.579 257.421Z",
    fill: "#231511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.884 356.79C298.779 356.79 295.984 355.548 293.811 353.374L275.49 335.053C274.248 333.811 274.248 331.948 275.49 330.705L290.705 315.49C291.948 314.248 293.811 314.248 295.053 315.49L313.374 333.811C317.721 338.158 317.721 345.3 313.374 349.958L309.648 353.684C307.784 355.548 304.99 356.79 301.884 356.79ZM282.321 333.19L298.158 349.027C300.021 350.89 303.437 350.89 305.3 349.027L309.027 345.3C310.89 343.437 310.89 340.021 309.027 338.158L293.19 322.321L282.321 333.19Z",
    fill: "#231511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.358 298.411C225.805 298.411 224.563 297.169 224.253 295.926C223.632 291.579 223.942 287.542 224.874 283.816C225.495 282.263 227.048 281.332 228.6 281.642C230.153 282.263 231.084 283.816 230.774 285.369C229.842 288.474 229.532 291.579 230.153 294.684C230.463 296.237 229.221 298.1 227.669 298.1C227.669 298.411 227.358 298.411 227.358 298.411Z",
    fill: "#00C256"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1188_2502",
    x: 0.549347,
    y: 0.358562,
    width: 518.903,
    height: 497.584,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.31752
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 86.3503
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.16625 0 0 0 0 0.7125 0 0 0 0 0.38475 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1188_2502"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1188_2502",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1188_2502",
    x: 195.348,
    y: 235.363,
    width: 111.304,
    height: 111.304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1188_2502"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1188_2502",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1188_2502",
    x1: 246.657,
    y1: 333.858,
    x2: 286.45,
    y2: 148.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B548",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1188_2502",
    x1: 227.686,
    y1: 256.503,
    x2: 279.27,
    y2: 334.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02B548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#02E95C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480953,
    stopColor: "#00FF64",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00481C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1188_2502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 118,
    fill: "white",
    transform: "translate(205 245)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundPage);
export default __webpack_public_path__ + "static/media/not-found-page.7797799bf6bd5d7692a958842eb1c93d.svg";
export { ForwardRef as ReactComponent };